
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Help() {
  const [activeCategory, setActiveCategory] = useState('常见问题');
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  const categories = [
    { name: '常见问题', icon: 'ri-question-line' },
    { name: '账户相关', icon: 'ri-user-line' },
    { name: '观看问题', icon: 'ri-play-circle-line' },
    { name: '技术支持', icon: 'ri-tools-line' },
    { name: '付费服务', icon: 'ri-vip-crown-line' },
    { name: '举报投诉', icon: 'ri-alarm-warning-line' }
  ];

  const faqs = {
    '常见问题': [
      {
        id: 1,
        question: '如何注册贝斯特体育账户？',
        answer: '您可以通过手机号、邮箱或第三方账户（微信、QQ）快速注册。点击页面右上角"登录/注册"按钮，选择注册方式，填写必要信息即可完成注册。注册后您将获得免费观看权限。'
      },
      {
        id: 2,
        question: '免费用户和VIP用户有什么区别？',
        answer: '免费用户可以观看部分免费赛事和精彩集锦，但会有广告展示。VIP用户可以无广告观看所有赛事直播、享受高清画质、多路信号切换、赛事回放等专属服务。'
      },
      {
        id: 3,
        question: '忘记密码怎么办？',
        answer: '在登录页面点击"忘记密码"，输入注册时使用的手机号或邮箱，系统将发送验证码或重置链接。按照提示完成密码重置即可。'
      },
      {
        id: 4,
        question: '支持哪些设备观看？',
        answer: '我们支持电脑网页端、手机APP、平板设备、智能电视等多种设备。您可以在不同设备间同步观看进度和收藏内容。'
      },
      {
        id: 5,
        question: '如何联系客服？',
        answer: '您可以通过在线客服（工作时间9:00-23:00）、客服热线400-888-8888、或发送邮件至service@bstyx.com联系我们。我们会在24小时内回复您的问题。'
      }
    ],
    '账户相关': [
      {
        id: 6,
        question: '如何修改个人资料？',
        answer: '登录后进入"个人中心"，点击"个人信息"即可修改昵称、头像、地区等信息。手机号和邮箱修改需要验证身份。'
      },
      {
        id: 7,
        question: '如何注销账户？',
        answer: '请联系客服申请账户注销。注销前请确认已取消所有付费订阅，注销后所有数据将无法恢复。'
      },
      {
        id: 8,
        question: '账户被封禁怎么办？',
        answer: '如果您的账户被误封，请通过客服邮件提供相关证明材料申请解封。我们会在3个工作日内处理并回复。'
      },
      {
        id: 9,
        question: '如何绑定第三方账户？',
        answer: '在"个人中心"-"账户安全"中可以绑定微信、QQ等第三方账户，绑定后可以使用第三方账户快速登录。'
      }
    ],
    '观看问题': [
      {
        id: 10,
        question: '视频卡顿怎么办？',
        answer: '请检查网络连接是否稳定，尝试刷新页面或切换清晰度。如问题持续，可尝试清除浏览器缓存或更换网络环境。'
      },
      {
        id: 11,
        question: '无法播放视频？',
        answer: '请确认浏览器版本较新并启用了JavaScript。建议使用Chrome、Safari、Edge等主流浏览器。如仍无法播放，请联系技术支持。'
      },
      {
        id: 12,
        question: '如何调整画质？',
        answer: '点击播放器右下角设置按钮，选择合适的画质。VIP用户可选择1080P高清，免费用户最高支持720P。'
      },
      {
        id: 13,
        question: '可以下载视频离线观看吗？',
        answer: '目前仅支持VIP用户下载部分精彩集锦内容离线观看，直播内容暂不支持下载。'
      }
    ],
    '技术支持': [
      {
        id: 14,
        question: '系统维护时间？',
        answer: '我们通常在每周二凌晨2:00-4:00进行系统维护。如有紧急维护，会提前24小时在首页公告。'
      },
      {
        id: 15,
        question: '支持哪些浏览器？',
        answer: '推荐使用Chrome 80+、Safari 13+、Firefox 75+、Edge 80+等现代浏览器，以获得最佳观看体验。'
      },
      {
        id: 16,
        question: 'APP在哪里下载？',
        answer: '您可以在App Store、Google Play、华为应用市场、小米应用商店等官方渠道下载贝斯特体育APP。'
      }
    ],
    '付费服务': [
      {
        id: 17,
        question: 'VIP会员如何开通？',
        answer: '点击页面上的"开通VIP"按钮，选择合适的套餐（月卡、季卡、年卡），支持微信支付、支付宝、银行卡等多种支付方式。'
      },
      {
        id: 18,
        question: 'VIP会员可以退款吗？',
        answer: '按照相关法规，数字内容产品一经消费不支持退款。如遇特殊情况，请联系客服协商处理。'
      },
      {
        id: 19,
        question: '如何取消自动续费？',
        answer: '在"个人中心"-"订阅管理"中可以关闭自动续费。也可以在支付平台（微信、支付宝）的订阅管理中取消。'
      }
    ],
    '举报投诉': [
      {
        id: 20,
        question: '如何举报不当内容？',
        answer: '发现违规内容请点击"举报"按钮，选择举报类型并提供详细说明。我们会在24小时内处理并回复结果。'
      },
      {
        id: 21,
        question: '如何投诉服务问题？',
        answer: '您可以通过客服热线、邮件或在线客服进行投诉。我们承诺在收到投诉后24小时内响应，3个工作日内给出处理结果。'
      },
      {
        id: 22,
        question: '版权投诉流程？',
        answer: '如认为我们的内容侵犯了您的版权，请发送书面通知至legal@bstyx.com，包含版权证明、侵权内容链接等信息。'
      }
    ]
  };

  const contactMethods = [
    {
      title: '在线客服',
      description: '7×24小时智能客服，工作时间人工服务',
      icon: 'ri-customer-service-2-line',
      action: '立即咨询',
      color: 'blue'
    },
    {
      title: '客服热线',
      description: '400-888-8888（工作时间：9:00-23:00）',
      icon: 'ri-phone-line',
      action: '拨打电话',
      color: 'green'
    },
    {
      title: '邮件支持',
      description: 'service@bstyx.com（24小时内回复）',
      icon: 'ri-mail-line',
      action: '发送邮件',
      color: 'purple'
    },
    {
      title: '社区求助',
      description: '在用户社区发帖求助，获得更多帮助',
      icon: 'ri-discuss-line',
      action: '前往社区',
      color: 'orange'
    }
  ];

  const filteredFaqs = faqs[activeCategory as keyof typeof faqs]?.filter(faq =>
    faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-green-500 to-blue-600 py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              帮助中心
            </h1>
            <p className="text-green-100 text-lg mb-8 max-w-2xl mx-auto">
              我们在这里为您解答疑问，提供全方位的服务支持
            </p>
            
            {/* 搜索框 */}
            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-search-line text-gray-400 text-xl"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索问题关键词..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-4 bg-white rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white/30 text-lg"
                />
              </div>
            </div>
          </div>
        </section>

        <div className="container mx-auto px-4 py-12">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* 左侧分类导航 */}
            <div className="lg:w-72 flex-shrink-0">
              <div className="bg-white rounded-lg shadow-sm p-6 sticky top-8">
                <h3 className="font-semibold text-gray-900 mb-4">问题分类</h3>
                <div className="space-y-2">
                  {categories.map((category) => (
                    <button
                      key={category.name}
                      onClick={() => setActiveCategory(category.name)}
                      className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors cursor-pointer ${
                        activeCategory === category.name
                          ? 'bg-green-50 text-green-600 font-medium'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`}
                    >
                      <i className={`${category.icon} text-lg`}></i>
                      <span>{category.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* 右侧内容区域 */}
            <div className="flex-1">
              {/* FAQ列表 */}
              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6 border-b border-gray-100">
                  <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                    <i className={`${categories.find(c => c.name === activeCategory)?.icon} text-green-600 mr-3`}></i>
                    {activeCategory}
                  </h2>
                  {searchQuery && (
                    <p className="text-sm text-gray-600 mt-2">
                      搜索"{searchQuery}"的结果：{filteredFaqs.length} 条
                    </p>
                  )}
                </div>

                <div className="divide-y divide-gray-100">
                  {filteredFaqs.length === 0 ? (
                    <div className="p-8 text-center">
                      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-search-line text-gray-400 text-2xl"></i>
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 mb-2">未找到相关问题</h3>
                      <p className="text-gray-500 mb-4">尝试使用其他关键词搜索，或浏览其他分类</p>
                      <button
                        onClick={() => setSearchQuery('')}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
                      >
                        清除搜索
                      </button>
                    </div>
                  ) : (
                    filteredFaqs.map((faq) => (
                      <div key={faq.id} className="p-6">
                        <button
                          onClick={() => setExpandedFaq(expandedFaq === faq.id ? null : faq.id)}
                          className="w-full flex items-center justify-between text-left cursor-pointer"
                        >
                          <h3 className="font-medium text-gray-900 flex-1 pr-4">
                            {faq.question}
                          </h3>
                          <i className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                            expandedFaq === faq.id ? 'rotate-180' : ''
                          }`}></i>
                        </button>
                        
                        {expandedFaq === faq.id && (
                          <div className="mt-4 pl-0">
                            <div className="bg-gray-50 rounded-lg p-4">
                              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                                {faq.answer}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* 联系方式 */}
          <section className="mt-16">
            <div className="text-center mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">还有其他问题？</h2>
              <p className="text-gray-600">选择最适合的方式联系我们，我们将竭诚为您服务</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {contactMethods.map((method, index) => (
                <div key={index} className="bg-white rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${
                    method.color === 'blue' ? 'bg-blue-100' :
                    method.color === 'green' ? 'bg-green-100' :
                    method.color === 'purple' ? 'bg-purple-100' :
                    'bg-orange-100'
                  }`}>
                    <i className={`${method.icon} text-2xl ${
                      method.color === 'blue' ? 'text-blue-600' :
                      method.color === 'green' ? 'text-green-600' :
                      method.color === 'purple' ? 'text-purple-600' :
                      'text-orange-600'
                    }`}></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">{method.title}</h3>
                  <p className="text-gray-600 text-sm mb-4">{method.description}</p>
                  <button className={`px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer ${
                    method.color === 'blue' ? 'bg-blue-500 hover:bg-blue-600 text-white' :
                    method.color === 'green' ? 'bg-green-500 hover:bg-green-600 text-white' :
                    method.color === 'purple' ? 'bg-purple-500 hover:bg-purple-600 text-white' :
                    'bg-orange-500 hover:bg-orange-600 text-white'
                  }`}>
                    {method.action}
                  </button>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
